<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <v-app id="inspire" light>
      <v-card color="grey lighten-5" flat>
        <v-layout row wrap>
          <v-flex xs12 sm12>
            <v-toolbar size="120px" dark color="info">
              <v-toolbar-title>BSP {{ $t('Periodic-Report')}}</v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>
  <v-icon left>email</v-icon> Mail Gönder
</v-btn>
              <v-menu offset-y>
                <v-btn slot="activator" dark icon>
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list>

                  <v-list-tile @click="getListHtml()">
                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>


                  <v-list-tile @click="getListExcel()">
                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>
                  </v-list-tile>

                </v-list>
              </v-menu>
            </v-toolbar>
          </v-flex>
        </v-layout>
        <v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>
  <v-card>
    <v-toolbar dense flat color="info" dark>
      <v-toolbar-title>Mail Gönder</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>
    </v-toolbar>

    <v-card-text>
      <v-form ref="mailForm" v-model="mailValid" lazy-validation>
        <v-layout wrap>
          <v-flex xs12>
            <v-text-field
              v-model="mailPayload.To"
              label="Kime (e-posta)"
              :rules="[rules.required, rules.email]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgencyName"
              label="Agency Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.DocType"
              label="Doc Type (sabit)"
              :rules="[rules.required]"
              :disabled="true"
            ></v-text-field>
          </v-flex>

          <v-flex xs12 sm6>
            <v-text-field
              v-model="mailPayload.AgentFullName"
              label="Agent Full Name"
              :rules="[rules.required]"
              clearable
            ></v-text-field>
          </v-flex>

          <v-flex xs12>
            <v-textarea
              v-model="mailPayload.CustomBody"
              label="Mesaj"
              :rules="[rules.required]"
              auto-grow
              rows="3"
            ></v-textarea>
          </v-flex>
        </v-layout>
      </v-form>
    </v-card-text>

    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="closeMailDialog">Vazgeç</v-btn>
      <v-btn
        color="info"
        :loading="mailLoading"
        :disabled="!mailValid || mailLoading"
        @click="sendMail"
      >
        <v-icon left>send</v-icon>Gönder
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>

        <v-container fluid="">
          <v-card flat>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>
              <v-layout row wrap>

                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" v-model="Rapor.BaslangicTarih"
                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]"></tarihcomp>
                </v-flex>
                <v-flex xs12 sm4 md2>
                  <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" v-model="Rapor.BitisTarih"
                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]"></tarihcomp>
                </v-flex>

                <v-flex>
                  <v-layout>
                    <div v-if="load1">
                      <v-btn color="info" @click="getList()" fab small="" dark>
                        <v-icon>search</v-icon>
                      </v-btn>
                    </div>
                    <div v-if="load1==false">
                      <v-layout fill-height align-center>
                        <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>
                      </v-layout>
                    </div>

                    <v-badge color="white" :overlap="true">
                      <template v-slot:badge>
                        <v-icon v-if="filtrevarmi" large color="green">
                          check_circle_outline </v-icon>
                      </template>

                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"
                        @click="filtrele()" color="info" fab dark>
                        <v-icon>filter_list</v-icon>
                      </v-btn>
                      <v-tooltip bottom="" :activator="el" v-model="tooltip">
                        <span>{{$t('Add-Search-Filter')}}</span>
                      </v-tooltip>



                    </v-badge>
                  </v-layout>
                </v-flex>

              </v-layout>
            </v-form>

            <v-flex xs12 sm12 md12 pb-3>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="#66BB6A">
                          <v-toolbar-title> <span class="subheading white--text">
                              {{ $t('Sales-Tickets') }}
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-flex xs6 sm6 md6>
                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"
                              :label="$t('Search')" append-icon="search"></v-text-field>
                          </v-flex>
                        </v-toolbar>

                      </v-flex>

                      <v-flex xs12 sm12>
                        <v-card flat>
                          <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :items="itemssatis"
                            :search="searchsatilanbilet">
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">{{ props.item.Date | dateformat }}</td>
                              <td class="text-xs-left">{{ props.item.TicketNumber }}</td>
                              <td class="text-xs-right">{{ props.item.NoComission | moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.Commission | moneyformat}}</td>
                              <td class="text-xs-right">{{ props.item.Tax | moneyformat}}</td>
                              <td class="text-xs-right">{{ props.item.Penalty| moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.Cash | moneyformat}}</td>
                              <td class="text-xs-right">{{ props.item.CreditCard  | moneyformat}}</td>
                              <td class="text-xs-center">{{ props.item.Percent }}</td>
                              <td class="text-xs-right">{{ props.item.CommissionAmount| moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.BPTA | moneyformat}}</td>



                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                               {{ $t('No-records-searched-for', { value: searchsatilanbilet}) }}
                            </v-alert>
                          </v-data-table>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" ma-2
                        xs12 sm12 md12>
                        <v-layout align-center="" justify-center="" fill-height="">
                          <span class="title grey--text font-weight-bold">
                            {{ $t('Sales-Tickets-Total') }}
                          </span>
                        </v-layout>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>

                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Count') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  No Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Commission') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Debit') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{$t('Cash')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Credit Cart
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Comission Amount
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  BPTA
                                </span>
                              </v-layout>
                            </v-flex>


                          </v-layout>
                          <v-divider light></v-divider>
                          <v-layout>

                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Count }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Commission | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Commission | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Tax | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Penalty | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.Cash | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.CreditCard | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.CommissionAmount | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{satisGen.BPTA | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <v-chip color="green"> <span class="subheading white--text"> {{ $t('Sales-Tickets-Total') }} </span>
                                </v-chip>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Count') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Count}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> No Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.NoComission  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Commission  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Tax  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Debit')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Penalty  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Cash')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.Cash  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Credit Card
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.CreditCard  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Comission Amount
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.CommissionAmount  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> BPTA
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{satisGen.BPTA  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <br />
            <v-flex xs12 sm12 md12 pb-3>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="red">
                          <v-toolbar-title> <span class="subheading white--text">
                              Refund Tickets
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-flex xs6 sm6 md6>
                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchiadebilet" :label="$t('Search')"
                              append-icon="search"></v-text-field>
                          </v-flex>
                        </v-toolbar>
                      </v-flex>

                      <v-flex xs12 sm12>
                        <v-card flat>
                          <v-data-table :headers="headerssatis" :rows-per-page-items=[20,100] :items="itemsiade"
                            :search="searchiadebilet">
                            <template slot="items" slot-scope="props">
                              <td class="text-xs-left">{{ props.item.Date | dateformat }}</td>
                              <td class="text-xs-left">{{ props.item.TicketNumber }}</td>
                              <td class="text-xs-right">{{ props.item.NoComission | moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.Commission | moneyformat}}</td>
                              <td class="text-xs-right">{{ props.item.Tax | moneyformat}}</td>
                              <td class="text-xs-right">{{ props.item.Penalty| moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.Cash | moneyformat}}</td>
                              <td class="text-xs-right">{{ props.item.CreditCard  | moneyformat}}</td>
                              <td class="text-xs-center">{{ props.item.Percent }}</td>
                              <td class="text-xs-right">{{ props.item.CommissionAmount| moneyformat }}</td>
                              <td class="text-xs-right">{{ props.item.BPTA | moneyformat}}</td>

                            </template>
                            <v-alert slot="no-results" :value="true" color="error" icon="warning">
                               {{ $t('No-records-searched-for', { value: searchiadebilet}) }}
                            </v-alert>
                          </v-data-table>
                        </v-card>
                      </v-flex>


                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" ma-2
                        xs12 sm12 md12>
                        <v-layout align-center="" justify-center="" fill-height="">
                          <span class="title grey--text font-weight-bold">
                            {{ $t('Refund-Ticket-Totals') }}
                          </span>
                        </v-layout>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>

                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Count') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  No Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Debit') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Cash') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Credit Cart
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Comission Amount
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  BPTA
                                </span>
                              </v-layout>
                            </v-flex>


                          </v-layout>
                          <v-divider light></v-divider>
                          <v-layout>

                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Count }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Commission | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Commission | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Tax | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Penalty | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.Cash | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.CreditCard | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.CommissionAmount | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{iadeGen.BPTA  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <v-chip color="red"> <span class="subheading white--text">  {{ $t('Refund-Ticket-Totals') }} </span>
                                </v-chip>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Count
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Count}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> No Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.NoComission  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Commission  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Tax  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Debit') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Penalty  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Cash') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.Cash  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Credit Card
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.CreditCard | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Comission Amount
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.CommissionAmount  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> BPTA
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{iadeGen.BPTA  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>

            <br />
            <v-flex xs12 sm12 md12 pb-3>
              <v-card class="white--text">
                <v-card flat="">
                  <v-card-actions>
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                        <v-toolbar flat="" size="120px" dark color="info">
                          <v-toolbar-title> <span class="subheading white--text">
                              Net Sales Total
                            </span> </v-toolbar-title>
                          <v-spacer></v-spacer>

                        </v-toolbar>
                      </v-flex>


                      <v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12
                        sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout>

                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Count') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  No Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Debit') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  {{ $t('Cash') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Credit Cart
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  Comission Amount
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="body-1 font-weight-">
                                  BPTA
                                </span>
                              </v-layout>
                            </v-flex>


                          </v-layout>
                          <v-divider light></v-divider>
                          <v-layout>

                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Count }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Commission  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Commission | moneyformat}}{{getparabirimi()}} </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Tax  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" row justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Penalty  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.Cash  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs1 sm1 md1>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.CreditCard  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>

                            <v-flex xs1 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.CommissionAmount  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs2 sm2 md2>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="caption font-weight-thin">
                                  {{gengen.BPTA  | moneyformat}}{{getparabirimi()}}
                                </span>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>

                      <v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>
                        <v-card flat class="grey--text">
                          <v-layout row wrap>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Count') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Count}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> No Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.NoComission  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Comission
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Commission  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Tax-v2') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Tax  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{ $t('Debit') }}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12 sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Penalty  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> {{$t('Cash')}}
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.Cash  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Credit Card
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.CreditCard  | moneyformat }}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> Comission Amount
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.CommissionAmount  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                            <v-flex xs12 sm12 md12>
                              <v-divider light></v-divider>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout align-center="" justify-center="" fill-height="">
                                <span class="subheading grey--text font-weight-bold"> BPTA
                                </span>
                              </v-layout>
                            </v-flex>
                            <v-flex xs12 sm12 md12>
                              <v-layout row wrap>
                                <v-flex xs12- sm12 md12>
                                  <v-layout align-center="" justify-center="" fill-height="">
                                    <span class="subheading font-weight-thin">
                                      {{gengen.BPTA  | moneyformat}}{{getparabirimi()}}
                                    </span>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>

                          </v-layout>
                        </v-card>
                      </v-flex>

                    </v-layout>

                  </v-card-actions>
                </v-card>
              </v-card>
            </v-flex>


          </v-card>
        </v-container>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"
          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
          {{ text1 }}
          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>
        </v-snackbar>


        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="500px">
          <v-card color="grey lighten-5">
            <v-card-title>{{ $t('Filter-selection') }}</v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-card class="white--text">
                <v-card color="grey lighten-5" flat="">
                  <v-card-actions>
                    <v-layout row="" wrap="">
                      <v-layout>
                        <v-flex xs12 sm12 md6>
                          <havayollaricomp :etiket="$t('Airline-Code')" v-model="havayolubil"></havayollaricomp>

                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-autocomplete hide-details="" v-model="Rapor.Masraf" :items="masrafmerkezi"
                            :label="$t('Expense-Center-v2')" item-text="Title" clearable item-value="Code" max-height="400">
                          </v-autocomplete>
                        </v-flex>

                      </v-layout>

                      <v-layout>
                        <v-flex xs12 sm12 md6>
                          <v-text-field v-model="Rapor.BaslangicBiletNo" :label="$t('Starting-Ticket-No')" mask="##########">
                          </v-text-field>
                        </v-flex>
                        <v-flex xs12 sm12 md6>
                          <v-text-field v-model="Rapor.BitisBiletNo" :label="$t('Ending-Ticket-No')" mask="##########">
                          </v-text-field>
                        </v-flex>

                      </v-layout>


                      <v-flex xs12 sm12 md12>
                        <div class="card__text grey darken-1 white--text">
                          <h3>{{$t('Options')}}</h3>
                        </div>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-radio-group :label="$t('Report-Type')" v-model="Rapor.RaporTipi" hide-details>
                          <v-radio :value="0" :label="$t('All')"></v-radio>
                          <v-radio :value="1" :label="$t('Sales')"></v-radio>
                          <v-radio :value="2" :label="$t('Refund')"></v-radio>
                          <v-radio :value="3" :label="$t('Void')"></v-radio>

                        </v-radio-group>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-radio-group :label="$t('Line-Type')" v-model="Rapor.HatTipi" hide-details>
                          <v-radio :value="0" label="BSP"></v-radio>
                          <v-radio :value="1" :label="$t('Charter')"></v-radio>
                          <v-radio :value="2" :label="$t('Service-v2')"></v-radio>
                          <v-radio :value="3" :label="$t('Difference')"></v-radio>
                          <v-radio :value="4" label="PTA"></v-radio>

                        </v-radio-group>
                      </v-flex>

                      <v-flex xs12 sm6 md3>
                        <v-radio-group :label="$t('Payment')" v-model="Rapor.OdemeTipi" hide-details>
                          <v-radio :value="0" :label="$t('All')"></v-radio>
                          <v-radio :value="1" :label="$t('Cash')"></v-radio>
                          <v-radio :value="2" :label="$t('With-Credit-Card')"></v-radio>
                        </v-radio-group>
                      </v-flex>


                      <v-flex xs12 sm6 md3>
                        <v-radio-group :label="$t('Raport-Order')" v-model="Rapor.Sira" hide-details>
                          <v-radio :value="0" :label="$t('Form-No')"></v-radio>
                          <v-radio :value="1" :label="$t('Ticket-Number')"></v-radio>
                        </v-radio-group>
                      </v-flex>

                      <v-flex xs12 sm6 md12>

                        <v-checkbox v-model="Rapor.Opsiyonlar.AcentaBas" :label="$t('Print-Receipts-Agency')"
                          hide-details="">
                        </v-checkbox>
                        <v-checkbox v-model="Rapor.Opsiyonlar.AmadeusGosterme" :label="$t('Dont-Show-Amadeus-Accounts')"
                          hide-details=""></v-checkbox>
                        <v-checkbox v-model="Rapor.Opsiyonlar.IcHatAmadeusSabre"
                          :label="$t('Show-Domestic-Amadeus-Sabre-Tickets')" hide-details=""></v-checkbox>
                        <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                      </v-flex>

                    </v-layout>
                  </v-card-actions>
                </v-card>
              </v-card>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>
              <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{$t('Apply-Filters')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-card>
    </v-app>
  </div>
</template>


<script>
  import auth from '../../../../api/auth'
  import tarihcomp from '../../customcomp/tarihim'
  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"
  import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"
  import helpers from "@/components/app/customcomp/helpers.js"
  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"



  export default {
    data() {
      return {
                mailDialog: false,
                        mailValid: false,
                        mailLoading: false,
                        mailPayload: {
                          To: "",
                          AgencyName: "",
                          DocType: "BSP Devre Raporu - BSP Periodic Report", 
                          AgentFullName: "",
                          CustomBody: ""
                        },
                        rules: {
                          required: v => !!v || 'Zorunlu alan',
                          email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || 'Geçerli bir e-posta girin'
                        },
        sayfayetki: {
          Screen: false,
          Update: false,
          Save: false,
          Delete: false,
          Status: false,
          Message: null,
          islem: 0,
        },
        filtrevarmi: false,
        searchsatilanbilet: null,
        searchiadebilet: null,
        itemssatis: [],
        itemsiade: [],

        doviztipi: [],
        havayolubil: {
          havayolukodu: null,
          formno: null
        },
        havayolubil2: {
          havayolukodu: null,
          formno: null
        },
        search: '',
        satisGen: {
          BPTA: 0,
          Cash: 0,
          Commission: 0,
          CommissionAmount: 0,
          Count: 0,
          CreditCard: 0,
          NoComission: 0,
          Penalty: 0,
          Service: 0,
          Tax: 0
        },
        iadeGen: {
          BPTA: 0,
          Cash: 0,
          Commission: 0,
          CommissionAmount: 0,
          Count: 0,
          CreditCard: 0,
          NoComission: 0,
          Penalty: 0,
          Service: 0,
          Tax: 0
        },
        gengen: {
          BPTA: 0,
          Cash: 0,
          Commission: 0,
          CommissionAmount: 0,
          Count: 0,
          CreditCard: 0,
          NoComission: 0,
          Penalty: 0,
          Service: 0,
          Tax: 0

        },
        Rapor: {
          SirketKodu: null,
          BaslangicTarih: null,
          BitisTarih: null,
          HavaYoluKodu: null,
          BaslangicBiletNo: null,
          BitisBiletNo: null,
          Masraf: null,
          RaporTipi: 0, // 0 : Hepsi, 1 : Satış, 2 : Iade
          OdemeTipi: 0, // 0: Hepsi, 1 : Peşin, 2 : Kredi Kartlı
          HatTipi: 0, //  0 : Bsp, 1: Charter, 2: Hizmet, 3 : Fark, 4 : Pta
          Sira: 0, //0 : Form No, 1  : Bilet No
          Opsiyonlar: {
            AcentaBas: false,
            AmadeusGosterme: false,
            IcHatAmadeusSabre: false,
            Charter: false
          }

        },
        itemsairlinelist: [],
        hesapgurubu: [],
        masrafmerkezi: [],
        valid: true,
        tumsirketler: '',
        totalCount: 0,
        totalService: 0,
        totalAmount: 0,
        StartDate: null,
        EndDate: null,
        date: null,
        menu: false,
        modal: false,
        dateFormatted: '',
        date2: null,
        menu2: false,
        dateFormatted2: '',
        modal2: false,
        loading: false,
        items: [],
        load: false,
        load1: true,
        search3: '',
        renk1: 'info',
        dialogfiltre: false,
        hesapkodu: [],
        kredikarti: [],
        statecari: [],
        searchcari: '',
        progress: false,
        tooltip: false,
        el: null,
        yok: false,
        itemsvoid: [],
        butondurum: true,
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: '',
        timeout: 6000,
        text1: '',
        dictionary: {
          custom: {

            tarihsec: {
              required: () => this.$t('Please-select-a-date')
            },
            tarihsec1: {
              required: () => this.$t('Please-select-a-date')
            },
          }
        },
      }
    },
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.prevRoute = from.path
      })
    },
    beforeMount: beforeMount,
    mounted() {
      this.$validator.localize('en', this.dictionary)
      this.el = this.$refs.fab.$el

      this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status == true) {
        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var params1 = {
          CompanyCode: credentials.SirketKodu
        }

        this.$http.post(auth.API_URL + 'api/currency/List', params1, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
          this.doviztipi = response.body
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
          } else {
            this.text1 = 'Service Unavailable-Döviz'
            this.snackbar = true
          }
        })

      } else {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {
              var url = '#' + this.prevRoute

              window.open(url, '_self')
            } else {
              var mainUrl = '#/'
              window.open(mainUrl, '_self')
            }
          } 

        });

      }
    },
    filters: {

      dateformat: function (t) {
        return helpers.dateformat(t);
      },
      moneyformat: function (m) {
        return helpers.moneyformat(m);
      },

      bakiyekontrol: function (m) {
        return helpers.bakiyekontrol(m);
      }

    },

    components: {
      'tarihcomp': tarihcomp,
      havayollaricomp,
      parkurcomp,
      yetkidialog
    },
    watch: {
      searchcari(val) {
        val && this.carigetir(val)
      }
    },
    methods: {
  openMailDialog: function () {
    var pageDocType = "BSP Devre Raporu - BSP Periodic Report";
    if (!this.mailPayload) this.mailPayload = {};
    this.mailPayload.DocType = pageDocType;

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {
      this.$refs.mailForm.resetValidation();
    }
    this.mailDialog = true;
  },

  closeMailDialog: function () {
    this.mailDialog = false;
  },

  sendMail: function () {
    var _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {
      return;
    }

    var bas = (_this.Rapor && _this.Rapor.BaslangicTarih) ? new Date(_this.Rapor.BaslangicTarih) : null;
    var bit = (_this.Rapor && _this.Rapor.BitisTarih) ? new Date(_this.Rapor.BitisTarih) : null;
    if (!(bas && bit && bas <= bit)) {
      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');
      _this.snackbar = true;
      return;
    }

    var credentialsRaw = window.localStorage.getItem('credentials');
    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};
    var companyCode = (_this.tumsirketler === true)
      ? 0
      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    var havaYoluKodu = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;

    var R = _this.Rapor || {};
    var inputObj = {
      SirketKodu: companyCode,
      BaslangicTarih: R.BaslangicTarih || null,
      BitisTarih: R.BitisTarih || null,
      HavaYoluKodu: havaYoluKodu,
      BaslangicBiletNo: R.BaslangicBiletNo || null,
      BitisBiletNo: R.BitisBiletNo || null,
      Masraf: R.Masraf || null,
      RaporTipi: (typeof R.RaporTipi !== 'undefined') ? R.RaporTipi : 0, 
      OdemeTipi: (typeof R.OdemeTipi !== 'undefined') ? R.OdemeTipi : 0, 
      HatTipi:   (typeof R.HatTipi   !== 'undefined') ? R.HatTipi   : 0, 
      Sira:      (typeof R.Sira      !== 'undefined') ? R.Sira      : 0, 
      Opsiyonlar: {
        AcentaBas: !!(R.Opsiyonlar && R.Opsiyonlar.AcentaBas),
        AmadeusGosterme: !!(R.Opsiyonlar && R.Opsiyonlar.AmadeusGosterme),
        IcHatAmadeusSabre: !!(R.Opsiyonlar && R.Opsiyonlar.IcHatAmadeusSabre),
        Charter: !!(R.Opsiyonlar && R.Opsiyonlar.Charter)
      }
    };

    var pageDocType = "BSP Devre Raporu - BSP Periodic Report";
    var mailObj = {
      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",
      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",
      DocType: (_this.mailPayload && _this.mailPayload.DocType) ? _this.mailPayload.DocType : pageDocType,
      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",
      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""
    };

    var payload = { Input: inputObj, Mail: mailObj };

    _this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/TicketPeriodReport/MailGonderBspDevreRaporExcel';

    _this.$http.post(
      endpoint,
      payload,
      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }
    ).then(function () {
      _this.mailLoading = false;
      _this.mailDialog = false;
      _this.text1 = 'Mail gönderildi.';
      _this.snackbar = true;
    }, function (err) {
      _this.mailLoading = false;
      var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};
      var msg = (body && (body.Message || body.message)) || err.statusText || 'Mail gönderilemedi.';
      _this.text1 = msg;
      _this.snackbar = true;
    });
  },


      getparabirimi() {
        return helpers.getparabirimi()
      },
      getList: getList,
      getListHtml: getListHtml,
      getListExcel: getListExcel,
      filtrele: filtrele,
      filtrekayit: filtrekayit,
      filtreiptal: filtreiptal,
    },
    computed:{
          headerssatis(){
            return [{
            text: this.$t('Date'),
            value: 'Date'
          },
          {
            text: this.$t('Ticket-Number'),
            value: 'TicketNumber'
          },
          {
            text: 'No Comission',
            value: 'NoCommission',
            align: 'center'
          },
          {
            text: 'Comission',
            value: 'Commission',
            align: 'center'
          },
          {
            text: this.$t('Tax-v2'),
            value: 'Tax',
            align: 'center'
          },
          {
            text: this.$t('Debit'),
            value: 'Penalty',
            align: 'center'
          },
          {
            text: this.$t('Cash'),
            value: 'Cash',
            align: 'center'
          },
          {
            text: 'Credit Cart',
            value: 'CreditCard',
            align: 'center'
          },
          {
            text: '%',
            value: 'Percent'
          },
          {
            text: 'Comission Amount',
            value: 'CommissionAmount',
            align: 'center'
          },
          {
            text: 'BPTA',
            value: 'BPTA',
            align: 'center'
          }
        ]
        },
        headervoid1(){
          return [{
            text: this.$t('Airline-code'),
            value: 'HavayoluKodu'
          },
          {
            text: this.$t('Ticket-No'),
            value: 'BiletNo'
          },
          {
            text: this.$t('Flight-Type'),
            value: 'UcusTip'
          },
          {
            text: this.$t('Description'),
            value: ''
          }

        ]
        },
        fiyatturu(){
          return [{
            text: 'AD-' + this.$t('Adult'),
            value: 'AD'
          },
          {
            text: 'CHD-' + this.$t('Child'),
            value: 'CHD'
          },
          {
            text: 'INF-' + this.$t('Baby'),
            value: 'INF'
          },
          {
            text: 'TUS-' + this.$t('Diplomatic'),
            value: 'TUS'
          },
          {
            text: 'EX',
            value: 'EX'
          },
          {
            text: 'STD-' + this.$t('Student'),
            value: 'STD'
          },
          {
            text: 'SRC-' + this.$t('Elderly'),
            value: 'SRC'
          },
          {
            text: 'MIL-' + this.$t('Soldier'),
            value: 'MIL'
          },
          {
            text: 'YTH-' + this.$t('Young'),
            value: 'YTH'
          }
        ]
        },
    }
  }


  function filtrele() {
    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {
      CompanyCode: credentials.SirketKodu
    }


    this.$http.post(auth.API_URL + 'api/currency/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.doviztipi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-Döviz'
        this.snackbar = true
      }
    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {
      headers: {
        'Authorization': 'Bearer ' + auth.getAuthHeader()
      }
    }).then((response) => {
      this.masrafmerkezi = response.body
    }, (response) => {
      if (response.status === 0) {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      } else {
        this.text1 = 'Service Unavailable-ExpenseCenter'
        this.snackbar = true
      }
    })


  }




  function filtrekayit() {
    this.filtrevarmi = true
    this.dialogfiltre = false
    this.getList()
  }

  function filtreiptal() {
    this.filtrevarmi = false
    this.dialogfiltre = false

    this.Rapor.SirketKodu = null
    this.Rapor.HavaYoluKodu = null
    this.Rapor.BaslangicBiletNo = null
    this.Rapor.BitisBiletNo = null
    this.Rapor.Masraf = null
    this.Rapor.RaporTipi = 0 // 0 : Hepsi, 1 : Satış, 2 : Iade
    this.Rapor.OdemeTipi = 0 // 0: Hepsi, 1 : Peşin, 2 : Kredi Kartlı
    this.Rapor.HatTipi = 0 //  0 : Bsp, 1: Charter, 2: Hizmet, 3 : Fark, 4 : Pta
    this.Rapor.Sira = 0 //0 : Form No, 1  : Bilet No
    this.Rapor.Opsiyonlar.AcentaBas = false
    this.Rapor.Opsiyonlar.AmadeusGosterme = false
    this.Rapor.Opsiyonlar.IcHatAmadeusSabre = false
    this.Rapor.Opsiyonlar.Charter = false
    this.havayolubil.havayolukodu = null
    this.tumsirketler = false

  }

  function getList() {

    if (this.$refs.formgunluksatis.validate()) {


      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;

      var params = this.Rapor

      this.$http.post(auth.API_URL + 'api/TicketPeriodReport/BspPeriodReport', params, {
        headers: {
          'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
      }).then((response) => {

        if (response.body.SatisBilgi.SatisBiletListe == null) {
          this.itemssatis = []

        } else {
          this.itemssatis = response.body.SatisBilgi.SatisBiletListe
        }


        if (response.body.IadeBilgi.IadeBiletListe == null) {
          this.itemsiade = []

        } else {
          this.itemsiade = response.body.IadeBilgi.IadeBiletListe
        }



        this.satisGen = response.body.SatisBilgi.SatisToplamlar
        this.iadeGen = response.body.IadeBilgi.IadeToplamlar
        this.gengen = response.body.GenelToplamlar

        this.progress = false
        this.load1 = true

      }, (response) => {
        if (response.status === 0) {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        } else {
          this.text1 = 'Service Unavailable'
          this.snackbar = true
          this.progress = false
          this.load1 = true
        }

      })

    }
  }



  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {
      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));
      var lang = localStorage.getItem('lang')
      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
      this.Rapor.AcentaKodu = this.havayolubil2.havayolukodu;

      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketPeriodReport/BspPeriodReportHtml", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          }
        }).then((response) => {
          this.progress = false
          this.load1 = true
          if (lang=='en')
          {
            
            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);
             bodyhtml=bodyhtml.toString().replace('<title> BORÇLU ALACAKLI LİSTESİ </title>','<title> DEBTOR CREDITOR LIST </title>');
             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>BORÇLU ALACAKLI LİSTESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>DEBTOR CREDITOR LIST</font>")

            
             response.bodyText=bodyhtml;
             
          }
          var blob = new Blob([response.bodyText], {
            type: 'application/html'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "BspDevre.html";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }


  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      this.progress = true
      this.load1 = false

      var credentials = JSON.parse(window.localStorage.getItem('credentials'));

      if (this.tumsirketler === true) {
        this.Rapor.SirketKodu = '0'
      } else {
        this.Rapor.SirketKodu = credentials.SirketKodu
      }

      this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu;
      this.Rapor.AcentaKodu = this.havayolubil2.havayolukodu;

      var params = this.Rapor

      this.$http
        .post(auth.API_URL + "api/TicketPeriodReport/BspPeriodReportExcel", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader()
          },
          responseType: "arraybuffer"
        }).then((response) => {
          this.progress = false
          this.load1 = true
          var blob = new Blob([response.data], {
            type: 'application/xlsx'
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "BspDevre.xlsx";
          link.click();
        }, (response) => {
          if (response.status === 0) {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          } else {
            this.text1 = 'Service Unavailable'
            this.snackbar = true
            this.progress = false
            this.load1 = true
          }
        })
    }
  }

  function beforeMount() {


  }
</script>
<style>

</style>